import React, { FC } from 'react';
import styles from './ClickableChip.module.css';
interface ClickableChipProps {
  chipText?: string;
  onClick?: (value: string) => void;
  disabled: boolean;
}

const ClickableChip: FC<ClickableChipProps> = ({
  onClick,
  chipText,
  disabled,
}) => {
  const onAction = () => {
    if (onClick && !disabled) onClick(chipText || '');
  };
  return (
    <div
      className={styles.styledChipContainer}
      role="button"
      onTouchEnd={(e): void => {
        // this stops the mobile keyboard (at least on ios) from
        // automatically hiding itself after a message is sent.
        e.preventDefault();
        onAction();
      }}
      onClick={onAction}
      onKeyDown={onAction}
      tabIndex={0}
    >
      {chipText}
    </div>
  );
};

export default ClickableChip;
